/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import './subcription.css'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const voiceSummaryMonthShape = PropTypes.shape({
    startDate: PropTypes.string,
    month: PropTypes.string,
    totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalCalls: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalSipTrunkFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

function Subcription(props) {
    const { summary, setTimeZone } = props;
    const [defaultTimeZone, setDefaultTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const navigate = useNavigate();

    const changeTimeZone = () => {
        if (defaultTimeZone === 'UTC') {
            setDefaultTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
            setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        } else {
            setDefaultTimeZone('UTC');
            setTimeZone('UTC');
        }
    }


    return (
        <>
            <>
                <main>
                    <section className="section-4">
                        <div className='w-100 text-start ps-4'>
                            <h5 className=''><i onClick={() => navigate(-1)}><KeyboardBackspaceIcon color='primary' fontSize='small' /></i>&nbsp;&nbsp;Transactions</h5>
                            <small>Showing all transactions in {defaultTimeZone !== "UTC" ? "your local timezone" : "UTC"},</small><button type="button" className='btn btn-link btn-sm' onClick={changeTimeZone}>Click to change to {defaultTimeZone === "UTC" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "UTC"}</button>
                        </div>

                        {summary.this_month ? <div className="section-4-2">
                            <div className="section-main">
                                <div className="pricing-body">
                                    <div className="pricing-body-plans">
                                        <div className="active" id="pricing__monthly__plan">
                                            <div>
                                                <div className="card">
                                                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                                                        <p>This month so far</p>
                                                        <p>({summary.this_month.startDate} - Present)</p>
                                                        <h2 className="card-price">${summary.this_month.totalAmount}</h2>
                                                    </div>
                                                    <div className="card-body">
                                                        <ul>
                                                            <li>
                                                                <p>Total calls</p>
                                                                <p className="price-color">{summary.this_month.totalCalls}</p>
                                                            </li>
                                                            <li>
                                                                <p>Total duration</p>
                                                                <p className="price-color">{summary.this_month.totalDuration} mins</p>
                                                            </li>
                                                            {summary.this_month.totalSipTrunkFees > 0 && <li>
                                                                <p>SIP Trunk Fees</p>
                                                                <p className="price-color">${summary.this_month.totalSipTrunkFees}</p>
                                                            </li>}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                                                        <p>Last month</p>
                                                        <p>({summary.last_month.month})</p>
                                                        <h2 className="card-price">${summary.last_month.totalAmount}</h2>
                                                    </div>
                                                    <div className="card-body">
                                                        <ul>
                                                            <li>
                                                                <p>Total calls</p>
                                                                <p className="price-color">{summary.last_month.totalCalls}</p>
                                                            </li>
                                                            <li>
                                                                <p>Total duration</p>
                                                                <p className="price-color">{summary.last_month.totalDuration} mins </p>
                                                            </li>
                                                            {summary.last_month.totalSipTrunkFees > 0 && <li>
                                                                <p>SIP Trunk Fees</p>
                                                                <p className="price-color">${summary.last_month.totalSipTrunkFees}</p>
                                                            </li>}
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-header" style={{ background: 'none', border: 'none' }}>
                                                        <p>The previous month</p>
                                                        <p>({summary.the_previous_month.month})</p>
                                                        <h2 className="card-price">${summary.the_previous_month.totalAmount}</h2>
                                                    </div>
                                                    <div className="card-body">
                                                        <ul>
                                                            <li>
                                                                <p>Total calls</p>
                                                                <p className="price-color">{summary.the_previous_month.totalCalls}</p>
                                                            </li>
                                                            <li>
                                                                <p>Total duration</p>
                                                                <p className="price-color">{summary.the_previous_month.totalDuration} mins</p>
                                                            </li>
                                                            {summary.the_previous_month.totalSipTrunkFees > 0 && <li>
                                                                <p>SIP Trunk Fees</p>
                                                                <p className="price-color">${summary.the_previous_month.totalSipTrunkFees}</p>
                                                            </li>}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : <div className="d-flex justify-content-center align-items-center">
                            <CircularProgress style={{ color: '#000', fontSize: '24px' }} />
                        </div>}
                    </section>
                </main>
            </>

        </>
    )
}

Subcription.propTypes = {
    summary: PropTypes.shape({
        this_month: voiceSummaryMonthShape,
        last_month: voiceSummaryMonthShape,
        the_previous_month: voiceSummaryMonthShape,
    }),
    setTimeZone: PropTypes.func.isRequired,
};

export default Subcription

